import type EnvConfig from "../models/envConfig"
import type { EnvString } from "../models/envConfig"

const envConfig: Ref<EnvConfig> = ref({
	grafanaUrlSuffix: "",
	dtrackUrl: "",
	appVersion: "",
	documentationUrl: "",
	logErrors: false,
	wsUrl: "",
	centrifugoChannelPrefix: "",
	emailNotVerifiedForDays: 0,
	environment: "dev"
})

export function useEnvConfig() {
	const rConfig = useRuntimeConfig()
	const loadEnvConfig = async () => {
		const config: EnvConfig = {
			appVersion: (rConfig.public.appVersion as string) ?? "1.0.0",
			documentationUrl: (rConfig.public.documentationUrl as string) ?? "",
			dtrackUrl: rConfig.public.dtrackUrl as string,
			grafanaUrlSuffix: rConfig.public.grafanaUrlSuffix as string,
			logErrors: false,
			wsUrl: rConfig.public.wsUrl as string,
			centrifugoChannelPrefix: rConfig.public.centrifugoChannelPrefix as string,
			emailNotVerifiedForDays: +(rConfig.public.emailNotVerifiedForDays as string),
			environment: rConfig.public.environment as EnvString
		}

		envConfig.value = config
	}

	return { loadEnvConfig, envConfig }
}
